import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Search, UsersRound, X } from "lucide-react";
import { AppDispatch, RootState } from "../../../../store";
import { getLoyaltyReferralCommission } from "../../../../Redux/referral/slice";
import Pagenation from "../../../../ecommerce/globalcomponents/pagenation/Pagenation";
import DateRangePicker from "../../../../ecommerce/globalcomponents/DateRangePicker";
import SponsorCommTable from "./SponsorCommTable";
import { formatEarningsCurrency } from "../earningsAdapters";
import "./LoyaltyReferralIncentives.css";

const SponsorCommission = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { loyaltyReferralCommission } = useSelector(
    (state: RootState) => state.referral,
  );

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [dateRange, setDateRange] = useState({ from: "", to: "" });

  // Debounce search
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(search);
    }, 500);
    return () => clearTimeout(timer);
  }, [search]);

  useEffect(() => {
    if (dateRange.from && !dateRange.to) return;

    dispatch(
      getLoyaltyReferralCommission({
        page,
        limit,
        status: "ALL",
        sortOrder: "DESC",
        search: debouncedSearch || undefined,
        startDate: dateRange.from || undefined,
        endDate: dateRange.to || undefined,
      }),
    );
  }, [dispatch, page, limit, debouncedSearch, dateRange.from, dateRange.to]);

  return (
    <section className="loyalty-referral-page">
      <div className="loyalty-referral-shell">
        <header className="loyalty-referral-header">
          <div className="loyalty-referral-heading">
            <span className="loyalty-referral-heading-icon">
              <UsersRound size={24} strokeWidth={2} />
            </span>
            <div>
              <span className="loyalty-referral-kicker">
                LOYALTY REFERRAL INCENTIVES
              </span>
              <h1>Loyalty Incentives</h1>
              <p>
                Track loyalty referral earnings, partner network activity
                and incentive status.
              </p>
            </div>
          </div>

          <div className="loyalty-referral-summary">
            <span>Total Received</span>
            <strong>
              {formatEarningsCurrency(
                loyaltyReferralCommission.totalLoyaltyReferralCommission,
              )}
            </strong>
          </div>
        </header>

        <div className="loyalty-referral-toolbar">
          <select
            value={limit}
            onChange={(e) => {
              setLimit(Number(e.target.value));
              setPage(1);
            }}
            aria-label="Entries per page"
          >
            {[10, 25, 50, 75, 100].map((val) => (
              <option value={val} key={val}>
                {val} Entries
              </option>
            ))}
          </select>

          <div className="loyalty-referral-date-picker">
            <DateRangePicker
              value={dateRange}
              onChange={(v) => {
                setDateRange(v);
                setPage(1);
              }}
            />
          </div>

          <div className="loyalty-referral-search">
            <Search size={18} strokeWidth={2} />
            <input
              type="search"
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                setPage(1);
              }}
              placeholder="Search loyalty incentives..."
              aria-label="Search loyalty referral incentives"
            />
            {search && (
              <button
                type="button"
                onClick={() => setSearch("")}
                aria-label="Clear search"
              >
                <X size={16} />
              </button>
            )}
          </div>
        </div>

        <SponsorCommTable data={loyaltyReferralCommission.data || []} />

        <Pagenation
          currentPage={page}
          totalPages={loyaltyReferralCommission.pagination?.totalPages || 0}
          onPageChange={setPage}
        />
      </div>
    </section>
  );
};

export default SponsorCommission;
